import { Icon, InputText, Tag } from "@uigovpe/components";
import { type KeyboardEvent, useState } from "react";
import { useController, useFormContext } from "react-hook-form";
import type { ProductFormValues } from "../types";

export default function ProductKeywords() {
  const { control } = useFormContext<ProductFormValues>();
  const {
    field,
    fieldState: { error },
  } = useController({
    name: "keywords",
    control,
    rules: {
      validate: (keywords) =>
        keywords.length < 2
          ? "Adicione pelo menos 2 palavras-chave."
          : keywords.length <= 8 || "Adicione no máximo 8 palavras-chave.",
    },
  });
  const [value, setValue] = useState("");
  const add = () => {
    const keyword = value.trim();
    if (keyword && !field.value.includes(keyword) && field.value.length < 8) {
      field.onChange([...field.value, keyword]);
      setValue("");
    }
  };
  const keyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      add();
    }
  };
  return (
    <section className="flex! flex-col! gap-5!">
      <div>
        <div className="flex! items-center! gap-2! text-base! font-bold! text-zinc-950!">
          <Icon icon="info" className="text-[#4e3873]!" />
          <h2 className="m-0!">Palavras-chave</h2>
        </div>
        <p className="mt-2! text-sm! text-[#28272c]!">
          Adicione até 8 palavras-chave para ajudar pessoas a encontrarem seu
          produto
        </p>
      </div>
      <InputText
        placeholder="Ex: Bolos Personalizados"
        className="w-full!"
        value={value}
        supportText={
          error?.message ??
          "Adicione pelo menos 2 palavras-chave. Pressione Enter para adicionar."
        }
        invalid={Boolean(error)}
        onBlur={field.onBlur}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={keyDown}
      />
      <div className="flex! flex-wrap! gap-2!">
        {field.value.map((keyword) => (
          <Tag
            key={keyword}
            value={keyword}
            icon={
              <Icon
                icon="close"
                className="cursor-pointer! text-[#4e3873]!"
                onClick={() =>
                  field.onChange(field.value.filter((item) => item !== keyword))
                }
              />
            }
            className="rounded-full! bg-violet-light! px-3! py-1! text-xs! font-medium! text-[#4e3873]!"
          />
        ))}
      </div>
    </section>
  );
}
